import { Link, useNavigate } from "react-router-dom";
import Loader from "../../../../Components/Loader"
import { GlobalInfo } from "../../../../Contexts/GlobalContext";
import { useContext, useEffect, useState } from "react";
import { SampleRequestService } from "../../../../Services/SampleRequest.Service";
import DurationDropdown from "./DurationDropdown";
import CompensationInput from "./CompensationInput";
import { LabsService } from "../../../../Services/Labs.service";
import DescriptionInput from "./DescriptionInput";
import Toaster from "../../../../Components/Toaster";
import { Helmet } from "react-helmet";
import TokenService from "../../../../Services/Token.service";
import ConfirmationModal from "../../../../Components/ConfirmationModal";
import { AdminService } from "../../../../Services/Admin.service";


const AppointmentDurationCompensationManagment = () => { 

    const [showDeleteModal, setShowDeleteModal] = useState(false); 
  
    const handleShowDeleteModal = () => setShowDeleteModal(true);
    const handleCloseDeleteModal = () => setShowDeleteModal(false);
   
    const confirmDeleteUser = () => {
      handleDeleteLab(selectedLab);
      handleCloseDeleteModal();
    };
 
    const handleDeleteLab = async (lab_id)=> {

        try{            
            const result = await AdminService.deleteAppointmentDurationCompensationDetailsWRTLab(lab_id);
            if(result.success){
                setShowToast(true);
                setToastMessage(result.message);
                setToastVariant("success");
                handleAddSampleType();

                // if(labs.length > 0){
                //     setSelectedLab(labs[0].id);
                //     setSelectedLabName(labs[0].name);
                // }
                fetchDurationCompensationAppointment();
            }
        }
        catch (error){
            setShowToast(true);
            setToastMessage(error.response.data.message);
            setToastVariant("danger"); 
        }
    }
    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [toastVariant, setToastVariant] = useState('');

    const navigate = useNavigate();
    const { appUserIsLogin, theme, toggleSidebar, isSidebarVisible } = useContext(GlobalInfo);
    const [loading, setLoading] = useState(false);
    const [formErrors, setFormErrors] = useState({});

    const [labs, setLabs] = useState([]);

    const [selectedLab, setSelectedLab] = useState(null);
    const [selectedLabName, setSelectedLabName] = useState(null);
    const [durationCompensationAppointment, setDurationCompensationAppointment] = useState([]);


    const [isAdd, setIsAdd] = useState();
   
    const fetchLabs = async () => {
        try {
            const response = await LabsService.getLabList();
            setLabs(response.labs || []);

            if(response.labs.length > 0 && response.labs.length > 0){
                setSelectedLab(response.labs[0].id);
                setSelectedLabName(response.labs[0].name);
            }
            
        } catch (error) {
            console.error("Error fetching labs", error);
        }
    };
    const fetchDurationCompensationAppointment = async () => {
        try {
            if (selectedLab) {
                setLoading(true);
                const params = { lab_id: selectedLab };
                const durationDetails = await SampleRequestService.getCompensationAndAppointmentDuationDetails(params);
                if (durationDetails.success) {
                  

                    if (durationDetails.success) {
                        const hasData = durationDetails.data.length > 0;
                        setDurationCompensationAppointment(hasData ? durationDetails.data : []);
                        
                        if(!hasData) {  
                            setIsAdd(true);
                            handleAddSampleType();
                        }
                        else{
                            setIsAdd(false);
                        }
                       
                    }
                    setLoading(false);
                }
                else{
                    setShowToast(true);
                    setToastMessage(durationDetails.message);
                    setToastVariant("danger");
                 
                }
            }
        } catch (error) {
            setLoading(false);
            setShowToast(true);
            setToastMessage("Error fetching appointment duration compensation details.");
            setToastVariant("danger");
            console.error("Error fetching DurationCompensationAppointment", error);
        }
    };

    useEffect(() => {
        fetchLabs();
    }, []);

    useEffect(() => {
        if (selectedLab) {
            fetchDurationCompensationAppointment();
            setFormErrors({});
        }
    }, [selectedLab]);


    const validateFields = () => { 
        const errors = {};
        durationCompensationAppointment.forEach((appointment) => {
            if (!appointment.duration) {
                errors[appointment.id] = {
                    ...errors[appointment.id],
                    duration: "This field is required",
                };
            }
            if (!appointment.cost) {
                errors[appointment.id] = {
                    ...errors[appointment.id],
                    cost: "This field is required",
                };
            }
            if (!appointment.additional_stick && appointment.sample_id === 1 ) {
                errors[appointment.id] = {
                    ...errors[appointment.id],
                    additional_stick: "This field is required",
                };
            }
             // Only validate description for sample_id 2 and 8
            if ([2, 8].includes(appointment.sample_id) && !appointment.description) {
                errors[appointment.id] = {
                    ...errors[appointment.id],
                    description: "This field is required",
                };
            }
            
        });
        setFormErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const isFormValid = () => { 
        // If there are any errors in formErrors object, return false 
        return Object.keys(formErrors).length === 0;
    };
    const handleSave = async (e) => {
        
        e.preventDefault();
        if (!validateFields()) {
            console.log("Form is not valid");
            setShowToast(true);
            setToastMessage("Please enter all Appointment Durations and Compensation details");
            setToastVariant("danger");
         
            return;
        }

        try {
            setLoading(true);            
        
            const updatedAppointments = {
                lab_id: selectedLab,  // Include lab_id
                sample_data: durationCompensationAppointment.map(appointment => {
                    const { id, ...appointmentWithoutId } = appointment;  // Destructure to remove 'id'
                    return appointmentWithoutId;  // Return the new object without 'id'
                })
            };

            if(isAdd){
              
                const response = await SampleRequestService.addDurationCompensationAppointment(updatedAppointments);
                if (response.success) {
    
    
                    setShowToast(true);
                    setToastMessage(response.message);
                    setToastVariant("success");
                    console.log(response.message);
                    setLoading(false);
                }
                else{
                    setShowToast(true);
                    setToastMessage(response.message);
                    setToastVariant("danger");
                    setLoading(false);
                }
                // setSelectedLab(null);
                // handleAddSampleType();
                // setLoading(false);
                fetchDurationCompensationAppointment();
            }
            else{
                const response = await SampleRequestService.updateDurationCompensationAppointment(updatedAppointments);
                if (response.success) {
    
    
                    setShowToast(true);
                    setToastMessage(response.message);
                    setToastVariant("success");
                    console.log(response.message);
                    setLoading(false);
                }
                else{
                    setShowToast(true);
                    setToastMessage(response.message);
                    setToastVariant("danger");
                    setLoading(false);
                }
            }
           

        } catch (error) {
            setLoading(false);

            setShowToast(true);
            setToastMessage("Error updating Appointment duration and compensation.");
            setToastVariant("danger");
            console.error('Error updating Compensation and Appointment:', error);
        }
    };

    const handleAddSampleType = () => { 
        const newSampleType = [
            {
            id:1,
            sample_id:1,
            sample_name: 'Blood', 
            duration: '',
            cost: '',
            description: '',
            from_range : 0,
            to_range : 100,
            additional_stick : 0
        }, {
            id:2,
            sample_id:1,
            sample_name: 'Blood', 
            duration: '',
            cost: '',
            description: '',
            from_range : 101,
            to_range : 200,
            additional_stick : 0
        },
        {
            id:3, 
            sample_id:2,
            sample_name: 'Urine', 
            duration: '',
            cost: '',
            description: '', 
        },
        {
            id:4, 
            sample_id:3,
            sample_name: 'Exhaled Breath', 
            duration: '',
            cost: '', 
        },
        {   
            id:5,
            sample_id:4,
            sample_name: "Saliva", 
            duration: '',
            cost: '', 
        },
        {   
            id:6,
            sample_id:5,
            sample_name: "Buccal Swabs", 
            duration: '',
            cost: '', 
        },
        {   
            id:7,
            sample_id:6,
            sample_name: "Hair Follicle", 
            duration: '',
            cost: '', 
        },
        {   
            id:8,
            sample_id:7,
            sample_name: "Skin Tape", 
            duration: '',
            cost: '', 
        },
        {   
            id:9,
            sample_id:8,
            sample_name: "Stool", 
            duration: '',
            cost: '',
            description: '', 
        },
    ];
       
        setDurationCompensationAppointment(newSampleType);
    };
    const previousUrl = TokenService.getPrevLink();
    return (
        <>
            <Helmet>
                <title>DonorX | Appointment Durations and Compensation</title>
            </Helmet>
            <Loader loading={loading} />
            <div className={`${!isSidebarVisible ? 'collapsed-body' : ''}`}>
                {/* <div className="container"> */}
                <div className="el-middle-wrapper">
                    <h2 className="el-title">Appointment Durations and Compensation</h2>
                    <Link className="back-link" to={`/admin/administrative-settings`}><i className='el-icon-back'></i> Administrator Settings</Link>
                    <div className="el-bg-table el-appoinment-duration">
                        <div className="row col-md-12">
                           
                            <div className="col-md-4 mb-4">
                                <label htmlFor="lab_id" className="form-label appointment-duration-compensation">Lab<span className="text-red">*</span></label>
                                <select
                                    as="select"
                                    name="lab_id"
                                    className="form-control"
                                    onChange={(e) => {
                                        const selectedLabId = e.target.value;
                                        const selectedLab = labs.find((lab) => lab.id.toString() === selectedLabId);
                                        setSelectedLab(selectedLabId); 
                                        setSelectedLabName(selectedLab ? selectedLab.name : null);
                                    }}
                                >                                    
                                    {labs.map((lab) => (
                                        <option key={lab.id}   value={lab.id}>{lab.name}</option>
                                    ))}
                                </select>
                            </div>
                      

                                                     
                        </div>
                        {(selectedLab!=null && selectedLab!="") && (    <div className="row col-md-12">
                            {/* Left Column */}
                            <div className="col-md-6">
                                {durationCompensationAppointment.slice(0, Math.ceil(durationCompensationAppointment.length / 2)).map((sampleType, index) => (
                                    <div key={index}>
                                        <div className="row mb-0">
                                            <DurationDropdown data={sampleType} label={sampleType.sample_name} durationCompensationAppointment={durationCompensationAppointment} setDurationCompensationAppointment={setDurationCompensationAppointment} setFormErrors={setFormErrors}  formErrors={formErrors}/>
                                            <CompensationInput data={sampleType} label={"Compensation"} durationCompensationAppointment={durationCompensationAppointment} setDurationCompensationAppointment={setDurationCompensationAppointment} setFormErrors={setFormErrors}  formErrors={formErrors}/>
                                            {/* {sampleType.description != null && (
                                                <DescriptionInput data={sampleType} label={sampleType.description} durationCompensationAppointment={durationCompensationAppointment} setDurationCompensationAppointment={setDurationCompensationAppointment} setFormErrors={setFormErrors}/>
                                            )} */}
                                            {[2, 8].includes(sampleType.sample_id) && (
                                                <DescriptionInput
                                                    data={sampleType}
                                                    label={sampleType.description}
                                                    durationCompensationAppointment={durationCompensationAppointment}
                                                    setDurationCompensationAppointment={setDurationCompensationAppointment}
                                                    setFormErrors={setFormErrors}
                                                    formErrors={formErrors}
                                                />
                                            )}
                                        </div>

                                        {/* Insert "Each Additional Stick" after the first index */}
                                        {((index === 1 && sampleType.sample_id === 1)) && (
                                            <div className="row mb-0">
                                                <CompensationInput data={sampleType} type={"blood-stick"} label={"Each Additional Stick"} durationCompensationAppointment={durationCompensationAppointment} setDurationCompensationAppointment={setDurationCompensationAppointment} setFormErrors={setFormErrors}  formErrors={formErrors}/>
                                            </div>
                                        )}
                                    </div>
                                ))}
                            </div>


                            {/* Right Column */}
                            <div className="col-md-6">
                                {durationCompensationAppointment.slice(Math.ceil(durationCompensationAppointment.length / 2)).map((sampleType, index) => (
                                    <div className="row mb-0" key={index}>
                                        <DurationDropdown data={sampleType} label={sampleType.sample_name} durationCompensationAppointment={durationCompensationAppointment} setDurationCompensationAppointment={setDurationCompensationAppointment} setFormErrors={setFormErrors}  formErrors={formErrors}/>
                                        <CompensationInput data={sampleType} label={"Compensation"} durationCompensationAppointment={durationCompensationAppointment} setDurationCompensationAppointment={setDurationCompensationAppointment} setFormErrors={setFormErrors}  formErrors={formErrors}/>
                                        {/* {sampleType.description != null && (
                                            <DescriptionInput data={sampleType} label={sampleType.description} durationCompensationAppointment={durationCompensationAppointment} setDurationCompensationAppointment={setDurationCompensationAppointment} setFormErrors={setFormErrors}/>
                                        )} */}
                                        {[2, 8].includes(sampleType.sample_id) && (
                                            <DescriptionInput
                                                data={sampleType}
                                                label={sampleType.description}
                                                durationCompensationAppointment={durationCompensationAppointment}
                                                setDurationCompensationAppointment={setDurationCompensationAppointment}
                                                setFormErrors={setFormErrors}
                                                formErrors={formErrors}
                                            />
                                        )}
                                    </div>
                                ))}
                            </div>

                            {selectedLab && (

                                <div className="col-12">
                                    <div className="d-flex my-3 w-fit-content justify-content-start">
                                       <button type="submit"  onClick={handleSave} className="el-main-button me-3"> <span> Save changes</span></button>                                       
                                        {!isAdd && selectedLab!=null && selectedLab!="" && (
                                            <> <button onClick={handleShowDeleteModal} className="el-error-button me-3" type="button"><span>Delete</span> </button> </>
                                        )}
                                       <Link to={`${previousUrl}`}><button type="button" className="close-btn close-btn-app-durat-comp"><span> Cancel</span>  </button></Link>
                                    </div>
                                </div>
                            )}

                        </div>) }
                    
                    </div>
                </div>
            </div>
            <Toaster
                show={showToast}
                message={toastMessage}
                variant={toastVariant}
                onClose={() => setShowToast(false)}
            />
             {/* Delete Confirmation Modal */}
            <ConfirmationModal
                show={showDeleteModal}
                onHide={handleCloseDeleteModal}
                onConfirm={confirmDeleteUser}
                title="Confirm Delete"
                body={`Are you sure you want to delete ${selectedLabName} Lab's appointment duration and compensation details?`}
            />
            {/* </div> */}
        </>
    );

}

export default AppointmentDurationCompensationManagment;